import Vue from 'vue'
import './plugins/main'
import uuid from "device-uuid";
import routes from './router/index.routes'
import { setLocalStorage, getLocalStorage } from './js/encryption'
import './mixins/navigation.mixin'

import './middlewares/interceptor'

import './filters/calculateAge'
import './filters/formatDate'
import './filters/replace'
import './filters/strLimit'
import './filters/toCpf'
import './filters/toCurrency'


import './mixins/global.mixin'

import App from './App.vue'

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  router: routes,
  // template: template,
  beforeCreate: function () {
    if (!getLocalStorage('device')) {
      let device = uuid.DeviceUUID().get();
      setLocalStorage('device', device);
    }
  },

}).$mount('#app')
